import { computed, toValue, watch } from 'vue';

/**
 * @description
 * reactive wrapper for the resize observer web api
 *
 * @param {HTMLElement} targetElement - the target element to be observed
 * @param {Function} handler - callback handler needed for accessing resize observer data
 */
export function useResizeObserver(targetElement, handler) {
    let observer;

    function cleanup() {
        if (!observer) return;
        observer.disconnect();
        observer = undefined;
    }

    const element = computed(() => toValue(targetElement));

    const stopWatch = watch(element, (el) => {
        cleanup();
        if (el && el instanceof HTMLElement) {
            observer = new ResizeObserver((entries) => {
                if (typeof handler === 'function') {
                    entries.forEach(handler);
                }
            });
            observer.observe(el);
        }
    }, { immediate: true, flush: 'post' });

    return () => {
        cleanup();
        stopWatch();
    };
}

export default {
    useResizeObserver,
};
